import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Row, Col, Button, Collapse, message } from 'antd';
import { connect } from 'react-redux';

import { Form, Field } from 'react-final-form';

import { TextField } from '../../atoms';
import { ClassificatorField } from '../../atoms/reduxForms';
import legalEntityStatus from '../../constants/classificators/legalEntityStatus';

import {
  FORM_SEARCH_FILTERS,
  searchFormFields,
} from '../../constants/formSearchFilters';
import { TableActions } from '../../components';
import { links, goToRegisterByAdmin } from '../../utils/gotoLink';
import { downloadFileByPostURL } from '../../utils/files';
import FormStateToRedux from '../FormStateToRedux';
import { updateFormState } from '../../reducers/reactFinalFormReducer';

import './SearchFilters.css';

const { Panel } = Collapse;

export class SearchFilters extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    searchLegalEntities: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.updateFormState(FORM_SEARCH_FILTERS, {
      values: this.props.initialValues,
    });
  }

  onClear = (form) => {
    const { initialValues, updateFormState, searchLegalEntities } = this.props;
    form.restart(initialValues);
    updateFormState(FORM_SEARCH_FILTERS, { values: initialValues });
    searchLegalEntities(initialValues);
  };

  handleExport = (form) => {
    const values = form.getState().values || {};
    downloadFileByPostURL(
      links.legalEntityExportCsv,
      values,
      'market-participants.csv'
    );
  };

  onSubmit = (values) => {
    const { t, searchLegalEntities } = this.props;
    const allEmpty = Object.values(values || {}).every((v) => isEmpty(v));
    if (allEmpty) {
      message.error(t('shouldFillAnyFilter'));
      return;
    }
    searchLegalEntities(values);
  };

  render() {
    const { t, initialValues } = this.props;

    return (
      <div className="search-form-container">
        <Collapse>
          <Panel header={`${t('search')} - ${t('market_participants')}`}>
            <div className="dropdown-search-form">
              <Form
                initialValues={initialValues}
                onSubmit={this.onSubmit}
                render={({ handleSubmit, form }) => (
                  <form onSubmit={handleSubmit}>
                    <FormStateToRedux form={FORM_SEARCH_FILTERS} />

                    <Row gutter={50}>
                      <Col span={8}>
                        <Field
                          name={searchFormFields.COMPANY_NAME}
                          component={TextField}
                          type="text"
                          label={t('company_name')}
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8}>
                        <Field
                          name={searchFormFields.REGISTER_CODE}
                          component={TextField}
                          type="text"
                          label={t('registry_code')}
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8}>
                        <Field
                          name={searchFormFields.EICX_CODE}
                          component={TextField}
                          type="text"
                          label={t('eicx_code')}
                          hasFeedback={false}
                        />
                      </Col>
                    </Row>

                    <Row gutter={50}>
                      <Col span={8}>
                        <Field
                          label={t('role')}
                          name={searchFormFields.COMPANY_ROLE}
                          component={ClassificatorField}
                          classificatorType={
                            ClassificatorField.types.legalEntityType
                          }
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8}>
                        <Field
                          allowed={[
                            legalEntityStatus.ACTIVE,
                            legalEntityStatus.INACTIVE,
                            legalEntityStatus.NEW,
                          ]}
                          label={t('status')}
                          name={searchFormFields.COMPANY_STATUS}
                          component={ClassificatorField}
                          classificatorType={
                            ClassificatorField.types.legalEntityStatus
                          }
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8} />
                    </Row>

                    <div className="main-options">
                      <Row type="flex" justify="end">
                        <Button
                          onClick={() => this.onClear(form)}
                          type="primary"
                          ghost
                        >
                          {t('cancel')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                          {t('submit')}
                        </Button>
                      </Row>
                    </div>

                    <TableActions>
                      <Button onClick={() => this.handleExport(form)}>
                        {t('exportCsvBtn')}
                      </Button>
                      <Button
                        className="global-margin-left-10"
                        type="primary"
                        onClick={goToRegisterByAdmin}
                      >
                        {t('add_client')}
                      </Button>
                    </TableActions>
                  </form>
                )}
              />
            </div>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (_state) => ({
  initialValues: {},
});

const mapDispatchToProps = {
  updateFormState,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilters);
